import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BetSlipModalComponent } from '../../modals/bet-slip-modal/bet-slip-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { StmgService } from "../../services/state_Management/stmg.service";
import { Subscription } from 'rxjs';
import { BettingServiceService } from '../../services/betting_service/betting-service.service';
import { CommonServiceService } from '../../services/common_service/common-service.service';
import { AlertController } from "@ionic/angular";
import { AlertComponent } from "../../components/alert/alert.component";
import { UserInfo } from '../../services/payload/userInfo_pobj';

@Component({
  selector: 'app-footer-bar',
  templateUrl: './footer-bar.component.html',
  styleUrls: ['./footer-bar.component.scss'],
})


export class FooterBarComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  eventSelections: any;
  item: any = 0;
  token: any;
  loginStatus: boolean;
  userInfo: UserInfo;
  is_logged = false;

  hasKironBets: boolean = false;
hasNormalBets: boolean = false;


  constructor(
    public modalController: ModalController,
    public translate: TranslateService,
    private stmgService: StmgService,
    private bettingService: BettingServiceService,
    private commonservice: CommonServiceService,
    public alertController: AlertController
  ) {
    //translate.use('en');
  }


  ngOnInit() {

    this.subscription = this.stmgService.cast_selectedBets.subscribe(selectedBets => {

      if (selectedBets) {

        // check Kiron Game obj or not
        if (selectedBets.payload) {
          this.item = selectedBets.payload.eventSelections.length;
        } else {
          // This is normal bet obj
          this.item = selectedBets.eventSelections.length;
        }
        this.eventSelections = selectedBets;

        // console.log("Bet Slips eventSelection ========= >>> ", this.eventSelections)

      }

    });

    this.subscription = this.stmgService.is_logged_status.subscribe(is_logged => this.loginStatus = is_logged);

    this.stmgService.is_logged_status.subscribe(message =>
      this.is_logged = message
    );

    this.stmgService.userInfoObervable.subscribe(userInfo =>
      this.userInfo = userInfo
    )

  }




  async openBetSlipModal() {

    // selected bet items
    if (this.item > 0) {

      // check is login
      if (this.loginStatus) {
        this.getEventSelctionsForPaceBet();

      } else {
        this.loginAlert();
      }

    } else {
      this.emptySelectionsAlert();
    }

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getEventSelctionsForPaceBet() {

    // console.log("Event Selections Footer : ", this.eventSelections)
    this.token = this.commonservice.getToken();

    // check Kiron Game obj or not
    if (this.eventSelections.payload) {
      this.bettingService.getEventSelectionforBetPlace_mdm(this.eventSelections, this.token).subscribe(data => {
        this.openPopup(data);
      }, (error) => {
      });
    } else {
      // This is normal bet obj
      this.bettingService.getEventSelectionforBetPlace(this.eventSelections, this.token).subscribe(data => {
        this.openPopup(data);

      }, (error) => {

      });
    }

  }

  
  emptySelectionsAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.NO_SELECTION.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.NO_SELECTION.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert(
      "", alertTitle, alertDesc
    );
  }

  loginAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.PLEASE_LOG.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.PLEASE_LOG.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert(
      "", alertTitle, alertDesc
    );
  }

  async openPopup(data) {
    const modal = await this.modalController.create({
      component: BetSlipModalComponent,
      cssClass: 'customPopup',
      componentProps: { data: data, bets: this.eventSelections }

    })
    return await modal.present();
  }


}
